import React, { Component } from 'react'
import { object, bool } from 'prop-types'
import { connect } from 'react-redux'
import { Fieldset, Row, Field } from 'react-gridforms'
import Input from 'bisu-react-input'
import RowSearch from 'bisu-react-row-search'

import InputCheckbox from 'components/InputCheckbox'
import { searchStudent } from 'containers/Students/actions'

class FormAdvising extends Component {

  render() {
    const {
      isShow,
      isNew,
      __resultStudents,
      __courses,
      __curriculums,
      __paymentschemes,
      __scholarships,
    } = this.props

    return (
      <Fieldset legend={' '} disabled={isShow}>
        <RowSearch
          placeholder="Search StudentID or Last Name"
          label1="Student ID"
          label2="Student Name"
          model="advisingState.student_id"
          model1="advisingState.student_id_code"
          model2="advisingState.student_name"
          onSearch={searchStudent}
          searchResults={__resultStudents}
          disabled={!isNew}
          autoFocus
          required
        />
        <Row>
          <Field>
            <Input
              model=".level"
              label="Year Level"
              required
            />
          </Field>
          <Field span="3">
            <InputCheckbox
              model=".is_open"
              label="Is open for enrolment (Check this only if full-merit scholar)"
            />
          </Field>
        </Row>
        <RowSearch
          placeholder="Search Course Code"
          label1="Course Code"
          label2="Course Name"
          model="advisingState.semcamp_course_id"
          model1="advisingState.course_code"
          model2="advisingState.course_name"
          searchResults={__courses}
          isOffline
          required
        />
        <RowSearch
          placeholder="Search Curriculum Code"
          label1="Curriculum Code"
          label2="Curriculum Name"
          model="advisingState.curriculum_id"
          model1="advisingState.curriculum_code"
          model2="advisingState.curriculum_name"
          searchResults={__curriculums}
          isOffline
          required
        />
        <RowSearch
          placeholder="Search PaymentScheme Code"
          label1="PaymentScheme Code"
          label2="PaymentScheme Name"
          model="advisingState.payment_scheme_id"
          model1="advisingState.paymentscheme_code"
          model2="advisingState.paymentscheme_name"
          searchResults={__paymentschemes}
          isOffline
          required
        />
        <RowSearch
          placeholder="Search Scholarship Code"
          label1="Scholarship Code"
          label2="Scholarship Name"
          model="advisingState.scholarship_id"
          model1="advisingState.scholarship_code"
          model2="advisingState.scholarship_name"
          searchResults={__scholarships}
          isOffline
        />
      </Fieldset>
    )
  }
}

FormAdvising.propTypes = {
  __resultStudents: object,
  __courses: object,
  __curriculums: object,
  __paymentschemes: object,
  __scholarships: object,
  isShow: bool,
}

function mapStateToProps(state) {
  return {
    __resultStudents: state.student.get('searchResults'),
    __courses: state.sccourse.get('list'),
    __curriculums: state.curriculum.get('list'),
    __paymentschemes: state.paymentscheme.get('list'),
    __scholarships: state.scscholarship.get('list'),
  }
}

export default connect(mapStateToProps)(FormAdvising)



// WEBPACK FOOTER //
// ./src/containers/Advising/form-advising.js